import { defineSlotRecipe } from '@chakra-ui/react';

/** Default dialog panel. Call sites can still override radius and padding. */
export const dialogSlotRecipe = defineSlotRecipe({
  slots: ['content'],
  base: {
    content: {
      bg: 'surface',
      color: 'text',
      borderColor: 'border',
    },
  },
});
